@if (item !== null) {
  <div class="flex flex-col w-full">
    <!-- Header -->
    <div (click)="item.active = !item.active" class="grid grid-cols-[1fr_auto] text-sm text-kaz-black font-semibold bg-[#FAFAFA] p-4 justify-center md:cursor-pointer">
      <span>{{item.header}}</span>
      <fa-icon [icon]="item.active ? 'chevron-up' : 'chevron-down' "></fa-icon>
    </div>
    <!-- Body -->
    @if (item.active) {
      <div animate.enter="kaz-slide-enter" animate.leave="kaz-slide-leave" class="text-sm text-kaz-black whitespace-pre-wrap p-4">
        <span>{{item.data}}</span>
      </div>
    }
    <div class="bg-[#D2D2D2] h-[1px] w-full"></div>
  </div>
}
